import * as PropTypes from 'prop-types';
import React from 'react';

import { Dropdown } from './Dropdown';

/**
 * Usage:
 *  <DropdownList defaultTitle="Select a pill Neo..." onChange={() => { }}>
 *    <DropdownListItem value="blue" title="Blue" description="the story ends..." />
 *    <DropdownListItem value="red" title="Red" description="you stay in Wonderland..." />
 *  </DropdownList>
 */
export class DropdownList extends React.Component<any, any> {
  static propTypes = {
    dropdownClass: PropTypes.string,
    toggleClass: PropTypes.string,
    defaultTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    defaultDescription: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    attachTo: PropTypes.string,
    attachment: PropTypes.string,
    children: PropTypes.node,
    label: PropTypes.string,
    forceTitle: PropTypes.string,
    targetClass: PropTypes.string
  };

  static defaultProps = {
    defaultTitle: '---'
  };

  render() {
    const selectedItem = {
      title: this.props.defaultTitle,
      description: this.props.defaultDescription,
      tag: this.props.tag
    };

    const items = React.Children.map(this.props.children, (item: any) => {
      const selected = item.props.value === this.props.value;
      if (selected) {
        selectedItem.title = item.props.title;
        selectedItem.description = item.props.description;
        selectedItem.tag = item.props.tag;
      }

      return React.cloneElement(item, { key: item.key, selected, onClick: item.props.onClick || this.props.onChange });
    });

    if (this.props.forceTitle) {
      selectedItem.title = this.props.forceTitle;
    }

    return (
      <Dropdown
        dropdownClass={this.props.dropdownClass}
        toggleClass={`ui-dropdown__toggle ${this.props.toggleClass}`}
        title={selectedItem.title}
        description={selectedItem.description}
        tag={selectedItem.tag}
        disabled={this.props.disabled}
        label={this.props.label}
        targetClass={this.props.targetClass}
        attachTo={this.props.attachTo}
        attachment={this.props.attachment}
      >
        <div className="ui-container_scroll">
          <ul className="ui-dropdown__list">{items}</ul>
        </div>
      </Dropdown>
    );
  }
}
